import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ArrowRight: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 25" fill="none">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="24.9702"
          width="24"
          height="24"
          rx="4"
          transform="rotate(-90 0 24.9702)"
          fill="#F0F0F0"
        />
        <path
          d="M10.059 7.19386L14.859 12.5939C15.058 12.8204 15.058 13.1594 14.859 13.3859L10.059 18.7858C9.83649 19.0175 9.47102 19.0328 9.22989 18.8206C8.98876 18.6084 8.95751 18.244 9.15899 17.9938L13.605 12.9899L9.15899 7.98586C9.00617 7.82676 8.95299 7.59664 9.0205 7.38662C9.08801 7.1766 9.26532 7.02057 9.48222 6.98031C9.69911 6.94005 9.92061 7.02206 10.059 7.19386Z"
          fill="#101F3B"
        />
      </svg>
      ;
    </SvgIcon>
  );
};

export default ArrowRight;
